import UserError from "helpers/UserError";

export default function RouteNotFound() {
  throw new UserError("找不到页面");
}
